@if (state.activeSyllabus) {
  <ion-button
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
    fill="clear"
    class="top-panel-button w-full min-w-0"
    [class.active]="menuTrigger.menuOpen"
  >
    <div class="flex min-w-0 items-center gap-2">
      @if (state.activeCourse?.icon; as icon) {
        <div class="flex w-[36px] flex-shrink-0 items-center justify-center">
          <dojo-icon [icon]="icon" [size]="26" />
        </div>
      }
      <span class="min-w-0 flex-1 truncate font-bold">{{ state.activeCourse?.shortLabel }}</span>
    </div>
  </ion-button>
}

<mat-menu #menu="matMenu" class="custom-mat-menu wide-width">
  <ng-template matMenuContent>
    <div class="flex flex-col">
      <div class="flex items-center border-b border-neutral-200 p-4">
        <h3 class="text-md text-secondary font-semibold">
          {{ 'my_courses' | transloco }}
        </h3>
      </div>

      <div class="overflow-hidden p-4">
        <dojo-selection-list
          [formCtrl]="courseSelectionCtrl"
          [options]="state.coursesOptions"
          [multiple]="false"
          [figureIconSize]="24"
          (optionSelected)="onCourseSelected($event)"
          [hideIndicator]="false"
          class="course-options"
        />
      </div>

      <div class="border-t border-neutral-200 p-4">
        <dojo-button fill="outline" (click)="openNewCourseDialog()" [customColor]="'sky'">
          <dojo-icon icon="plus" class="mr-2"></dojo-icon>
          {{ 'add_new_course' | transloco }}
        </dojo-button>
      </div>
    </div>
  </ng-template>
</mat-menu>
